var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseWindow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close-Window",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6066017,4.08562073e-13 L11.992531,1.38592929 L7.381,5.996 L11.992531,10.6066017 L10.6066017,11.992531 L5.996,7.381 L1.38592929,11.992531 L4.42312853e-13,10.6066017 L4.61,5.996 L4.42312853e-13,1.38592929 L1.38592929,4.08451051e-13 L5.996,4.61 L10.6066017,4.08562073e-13 Z",
    id: "Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWindow);
export default __webpack_public_path__ + "static/media/Close Window.a2452b5229569fe379a3dfbbff3b48d6.svg";
export { ForwardRef as ReactComponent };